import {ReactNode} from "react"
import styled from "styled-components"

import BackArrow from "react-icons/lib/md/arrow-back"
import Info from "react-icons/lib/md/info-outline"
import Menu from "react-icons/lib/md/menu"

import AngleLeft from "react-icons/lib/fa/angle-left"
import AngleRight from "react-icons/lib/fa/angle-right"
import AngleUp from "react-icons/lib/fa/angle-up"
import AngleDown from "react-icons/lib/fa/angle-down"
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes"
import EditPencil from "react-icons/lib/fa/edit"
import Ellipsis from "react-icons/lib/fa/ellipsis-h"
import OldComment from "react-icons/lib/fa/comment-o"
import OldCommented from "react-icons/lib/fa/comment"
import OldReward from "react-icons/lib/fa/gift"
import Pause from "react-icons/lib/fa/pause"
import Play from "react-icons/lib/fa/play"
import Trashcan from "react-icons/lib/fa/trash-o"
import UpArrow from "react-icons/lib/fa/chevron-up"
import Vote from "react-icons/lib/fa/heart-o"
import Voted from "react-icons/lib/fa/heart"
import Refresh from "react-icons/lib/fa/refresh"
import Google from "react-icons/lib/fa/google"

import AddAdmin from "./customIcons/AddAdmin"
import AddBookmark from "./customIcons/AddBookmark"
import AddComment from "./customIcons/AddComment"
import AddEmoji from "./customIcons/AddEmoji"
import AddReward from "./customIcons/AddReward"
import Announcement from "./customIcons/Announcement"
import Apps from "./customIcons/Apps"
import Archive from "./customIcons/Archive"
import Attachment from "./customIcons/Attachment"
import Blog from "./customIcons/Blog"
import CircleHollow from "./customIcons/CircleHollow"
import CircleTick from "./customIcons/CircleTick"
import Clipboard from "./customIcons/Clipboard"
import Clock from "./customIcons/Clock"
import Close from "./customIcons/Close"
import Comment from "./customIcons/Comment"
import {CelebrationNexus} from "./customIcons/svg/CelebrationNexus"
import Coupon from "./customIcons/Ticket"
import CustomReward from "./customIcons/CustomReward"
import Delete from "./customIcons/Delete"
import DisabledEditQuestion from "./customIcons/DisabledEditQuestion"
import DoctorCareAnywhere from "./customIcons/DoctorCareAnywhere"
import DotDotDot from "./customIcons/DotDotDot"
import DownArrow from "./customIcons/DownArrow"
import DownloadFile from "./customIcons/DownloadFile"
import Duplicate from "./customIcons/Duplicate"
import EditQuestion from "./customIcons/EditQuestion"
import Emoji from "./customIcons/Emoji"
import EmojiActive from "./customIcons/EmojiActive"
import Event from "./customIcons/Event"
import EyeSlash from "./customIcons/EyeSlash"
import FileDownload from "./customIcons/FileDownload"
import FilterActive from "./customIcons/FilterActive"
import GeoArrow from "./customIcons/GeoArrow"
import GeoPin from "./customIcons/GeoPin"
import HeartOutline from "./customIcons/HeartOutline"
import Help from "./customIcons/Help"
import I from "./customIcons/I"
import Instant from "./customIcons/Instant"
import Landscape from "./customIcons/Landscape"
import Launch from "./customIcons/Launch"
import LogoBox from "./customIcons/LogoBox"
import Logout from "./customIcons/Logout"
import MobileAppOnly from "./customIcons/MobileAppOnly"
import MobileSecondaryNav from "./customIcons/MobileSecondaryNav"
import More from "./customIcons/More"
import MyPerks from "./customIcons/MyPerks"
import MyRecognition from "./customIcons/MyRecognition"
import Newsletter from "./customIcons/Newsletter"
import NewTab from "./customIcons/NewTab"
import OneHour from "./customIcons/Time"
import Online from "./customIcons/Online"
import OpenTab from "./customIcons/OpenTab"
import Padlock from "./customIcons/Padlock"
import Party from "./customIcons/Party"
import Payment from "./customIcons/Payment"
import People from "./customIcons/People"
import Person from "./customIcons/Person"
import Physical from "./customIcons/TopUpCard"
import Pin from "./customIcons/Pin"
import PinFilled from "./customIcons/PinFilled"
import PiggyBank from "./customIcons/PiggyBank"
import PlayVideo from "./customIcons/PlayVideo"
import Poll from "./customIcons/Poll"
import ProductsMedical from "./customIcons/Product-Medical"
import ProductsPerks from "./customIcons/Product-Perks"
import ProductsRecognition from "./customIcons/Product-Recognition"
import ProductsWellness from "./customIcons/Product-Wellness"
import Question from "./customIcons/Question"
import Reminder from "./customIcons/Reminder"
import RemoveBookmark from "./customIcons/RemoveBookmark"
import Report from "./customIcons/Report"
import Restore from "./customIcons/Restore"
import RewardActive from "./customIcons/RewardActive"
import RightArrow from "./customIcons/RightArrow"
import SeeResults from "./customIcons/SeeResults"
import SendExampleSurvey from "./customIcons/SendExampleSurvey"
import Share from "./customIcons/Share"
import SharedUser from "./customIcons/SharedUser"
import SimpleFavourite from "./customIcons/SimpleHeartFilled"
import SimpleFavouriteOutline from "./customIcons/SimpleHeart"
import Sort from "./customIcons/Sort"
import Stop from "./customIcons/Stop"
import SummaryComments from "./customIcons/SummaryComments"
import SummaryRecognitions from "./customIcons/SummaryRecognitions"
import SummaryTrophies from "./customIcons/SummaryTrophies"
import Tag from "./customIcons/Tag"
import TimeLimitedPerk from "./customIcons/TimeLimitedPerk"
import ThumbsUp from "./customIcons/ThumbsUp"
import User from "./customIcons/User"
import Values from "./customIcons/Values"
import Visibility from "./customIcons/Visibility"

import AdminRolesPermissions from "./customIcons/AdminRolesPermissions"
import AdminLoginIntegrations from "./customIcons/AdminLoginIntegrations"
import AdminReports from "./customIcons/AdminReports"
import AdminHelp from "./customIcons/AdminHelp"

// ================================================================ New icons
import AccessTime from "./customIcons/svg/AccessTime"
import AdminHome from "./customIcons/svg/AdminHome"
import Analytics from "./customIcons/svg/Analytics"
import ArrowDown from "./customIcons/svg/ArrowDown"
import ArrowLeft from "./customIcons/svg/ArrowLeft"
import ArrowRight from "./customIcons/svg/ArrowRight"
import ArrowUp from "./customIcons/svg/ArrowUp"
import ArrowUpDown from "./customIcons/svg/ArrowUpDown"
import Automation from "./customIcons/svg/Automation"
import Bin from "./customIcons/svg/Bin"
import Bookmark from "./customIcons/svg/Bookmark"
import BookmarkFill from "./customIcons/svg/BookmarkFill"
import BusinessUnit from "./customIcons/svg/BusinessUnit"
import BurgerMenu from "./customIcons/svg/BurgerMenu"
import Calendar from "./customIcons/svg/Calendar"
import Call from "./customIcons/svg/Call"
import CapsLockOn from "./customIcons/svg/CapsLockOn"
import Categories from "./customIcons/svg/Categories"
import Checklist from "./customIcons/svg/Checklist"
import Check from "./customIcons/svg/Check"
import ChevronDown from "./customIcons/svg/ChevronDown"
import ChevronLeft from "./customIcons/svg/ChevronLeft"
import ChevronRight from "./customIcons/svg/ChevronRight"
import ChevronUp from "./customIcons/svg/ChevronUp"
import Circle from "./customIcons/svg/Circle"
import CircleAlert from "./customIcons/svg/CircleAlert"
import CircleAlertFill from "./customIcons/svg/CircleAlertFill"
import CircleCrossFill from "./customIcons/svg/CircleCrossFill"
import CircleDisable from "./customIcons/svg/CircleDisable"
import CircleFastForward from "./customIcons/svg/CircleFastForward"
import CircleInformation from "./customIcons/svg/CircleInformation"
import CirclePause from "./customIcons/svg/CirclePause"
import CirclePlay from "./customIcons/svg/CirclePlay"
import CircleQuestion from "./customIcons/svg/CircleQuestion"
import CircleTickFill from "./customIcons/svg/CircleTickFill"
import CircleCheckFill from "./customIcons/svg/CircleCheckFill"
import CircleExpand from "./customIcons/svg/CircleExpand"
import CircleContract from "./customIcons/svg/CircleContract"
import CircleArrowRight from "./customIcons/svg/CircleArrowRight"
import CirclePlusFilled from "./customIcons/svg/CirclePlusFilled"
import CircleMinus from "./customIcons/svg/CircleMinus"
import Collapse from "./customIcons/svg/Collapse"
import Currency from "./customIcons/svg/Currency"
import CompanyBenefit from "./customIcons/svg/CompanyBenefit"
import Countries from "./customIcons/svg/Countries"
import MediaCourse from "./customIcons/svg/MediaCourse"
import Cross from "./customIcons/svg/Cross"
import CsvFile from "./customIcons/svg/CsvFile"
import DeletedFile from "./customIcons/svg/DeletedFile"
import Download from "./customIcons/svg/Download"
import Customisation from "./customIcons/svg/Customisation"
import Document from "./customIcons/svg/Document"
import DownloadReport from "./customIcons/svg/DownloadReport"
import Edit from "./customIcons/svg/Edit"
import Email from "./customIcons/svg/Email"
import Expand from "./customIcons/svg/Expand"
import Export from "./customIcons/svg/Export"
import Eye from "./customIcons/svg/Eye"
import EyeDisabled from "./customIcons/svg/EyeDisabled"
import Favourite from "./customIcons/svg/Favourite"
import FavouriteFill from "./customIcons/svg/FavouriteFill"
import Funnel from "./customIcons/svg/Funnel"
import Filter1 from "./customIcons/svg/Filter-1"
import Filter2 from "./customIcons/svg/Filter-2"
import Filter3 from "./customIcons/svg/Filter-3"
import FilterHighToLow from "./customIcons/svg/FilterHighToLow"
import FilterLowToHigh from "./customIcons/svg/FilterLowToHigh"
import FilterUpAndDown from "./customIcons/svg/FilterUpAndDown"
import FlexiPoints from "./customIcons/svg/FlexiPoints"
import FlexiPointsFilled from "./customIcons/svg/FlexiPointsFilled"
import GenerateReport from "./customIcons/svg/GenerateReport"
import Globe from "./customIcons/svg/Globe"
import Home from "./customIcons/svg/Home"
import HomeFill from "./customIcons/svg/HomeFill"
import Information from "./customIcons/svg/Information"
import Integration from "./customIcons/svg/Integration"
import Label from "./customIcons/svg/Label"
import LightBulb from "./customIcons/svg/LightBulb"
import Location from "./customIcons/svg/Location"
import Minus from "./customIcons/svg/Minus"
import Notification from "./customIcons/svg/Notification"
import NotificationBold from "./customIcons/svg/NotificationBold"
import NotificationFilled from "./customIcons/svg/NotificationFilled"
import MultiComments from "./customIcons/svg/MultiComments"
import MultiCommentsFilled from "./customIcons/svg/MultiCommentsFilled"
import Package from "./customIcons/svg/Package"
import Pending from "./customIcons/svg/Pending"
import Plus from "./customIcons/svg/Plus"
import Profile from "./customIcons/svg/Profile"
import Results from "./customIcons/svg/Results"
import Reward from "./customIcons/svg/Reward"
import Reward2 from "./customIcons/svg/Reward-2"
import Search from "./customIcons/svg/Search"
import SearchPeople from "./customIcons/svg/SearchPeople"
import Send from "./customIcons/svg/Send"
import Settings from "./customIcons/svg/Settings"
import Speech from "./customIcons/svg/Speech"
import SpeechPlus from "./customIcons/svg/SpeechPlus"
import Star from "./customIcons/svg/Star"
import StarFill from "./customIcons/svg/StarFill"
import Survey from "./customIcons/svg/Survey"
import Tick from "./customIcons/svg/Tick"
import ShoppingCart from "./customIcons/svg/ShoppingCart"
import SingleMedia from "./customIcons/svg/SingleMedia"
import UploadReport from "./customIcons/svg/UploadReport"
import Wallet from "./customIcons/svg/Wallet"
import Hypnosis from "./customIcons/svg/Hypnosis"
import Meditation from "./customIcons/svg/Meditation"
import SleepStories from "./customIcons/svg/SleepStories"
import TalkingTherapy from "./customIcons/svg/TalkingTherapy"
import Teams from "./customIcons/svg/Teams"
import Workout from "./customIcons/svg/Workout"
import Yoga from "./customIcons/svg/Yoga"
import Webinars from "./customIcons/svg/Webinars"
import Files from "./customIcons/svg/Files"
import UploadCSV from "./customIcons/svg/UploadCSV"
import UserPlus from "./customIcons/svg/UserPlus"
import UserFilled from "./customIcons/svg/UserFilled"
import UpRightArrow from "./customIcons/svg/UpRightArrow"
import Rewards from "./customIcons/svg/Rewards"
import RewardsFill from "./customIcons/svg/RewardsFill"
import TravelBenefit from "./customIcons/svg/TravelBenefit"
import TravelBenefitFill from "./customIcons/svg/TravelBenefitFill"
import PensionTopUp from "./customIcons/svg/PensionTopUp"
import PensionTopUpFill from "./customIcons/svg/PensionTopUpFill"
import GymBenefit from "./customIcons/svg/GymBenefit"
import GymBenefitFill from "./customIcons/svg/GymBenefitFill"
import HealthCashPlan from "./customIcons/svg/HealthCashPlan"
import HealthCashPlanFill from "./customIcons/svg/HealthCashPlanFill"
import SalaryFinance from "./customIcons/svg/SalaryFinance"
import SalaryFinanceFill from "./customIcons/svg/SalaryFinanceFill"
import PayrollGiving from "./customIcons/svg/PayrollGiving"
import PayrollGivingFill from "./customIcons/svg/PayrollGivingFill"
import CarBenefit from "./customIcons/svg/CarBenefit"
import CarBenefitFill from "./customIcons/svg/CarBenefitFill"

import IconTypes from "./IconTypes.enum"
import LiveBanner from "./customIcons/svg/LiveBanner"
import Wellness from "./customIcons/svg/Wellness"
import Medical from "./customIcons/svg/Medical"
import Celebration from "./customIcons/svg/Celebration"
import Perks from "./customIcons/svg/Perks"
import CelebrationFill from "./customIcons/svg/CelebrationFill"
import PerksFill from "./customIcons/svg/PerksFill"
import PersonSearch from "./customIcons/svg/PersonSearch"
import WellnessFill from "./customIcons/svg/WellnessFill"
import MedicalFill from "./customIcons/svg/MedicalFill"
import RewardPoints from "./customIcons/svg/RewardPoints"
import Audio from "./customIcons/svg/Audio"
import Video from "./customIcons/svg/Video"
import CircleCelebration from "./customIcons/svg/CircleCelebration"
import CirclePerks from "./customIcons/svg/CirclePerks"
import CircleWellness from "./customIcons/svg/CircleWellness"
import Warning from "./customIcons/svg/Warning"
import CircleRewards from "./customIcons/svg/CircleRewards"
import CircleAdmin from "./customIcons/svg/CircleAdmin"
import Pinned from "./customIcons/svg/Pinned"
import All from "./customIcons/svg/All"
import Flexi from "./customIcons/svg/Flexi"
import Billing from "./customIcons/Billing"
import Truck from "./customIcons/svg/Truck"
import MsTeams from "./customIcons/svg/MsTeams"
import Payments from "./customIcons/svg/Payments"
import PayByCard from "./customIcons/svg/PayByCard"
import CelebrationAnimated from "./customIcons/CelebrationAnimated"
import SavingsAnimated from "./customIcons/SavingsAnimated"
import ShareAnimated from "./customIcons/ShareAnimated"
import ShareTo from "./customIcons/svg/ShareTo"
import Copy from "./customIcons/svg/Copy"
import CultureHub from "./customIcons/svg/CultureHub"
import CultureHubFill from "./customIcons/svg/CultureHubFill"
import InfoBlack from "./customIcons/svg/InfoBlack"
import VerifyBusiness from "./customIcons/svg/VerifyBusiness"
import VerifyIdentity from "./customIcons/svg/VerifyIdentity"
import HomeElectronics from "./customIcons/svg/HomeElectronics"
import HomeElectronicsFill from "./customIcons/svg/HomeElectronicsFill"
import CycleToWork from "./customIcons/svg/CycleToWork"
import CycleToWorkFill from "./customIcons/svg/CycleToWorkFill"
import AnnualLeavePurchaseFill from "./customIcons/svg/AnnualLeavePurchaseFill"
import AnnualLeavePurchase from "./customIcons/svg/AnnualLeavePurchase"
import ExternalLink from "./customIcons/svg/ExternalLink"
import HourGlass from "./customIcons/svg/HourGlass"
import Cart from "./customIcons/svg/Cart"
import InfoPrimary1 from "./customIcons/svg/InfoPrimary1"
import Spinner from "./customIcons/svg/Spinner"
import History from "./customIcons/svg/History"
import VideoFilled from "./customIcons/svg/VideoFilled"
import OrderManagement from "./customIcons/svg/OrderManagement"
import Outlook from "./customIcons/svg/Outlook"
import Article from "./customIcons/svg/Article"
import HeartHand from "./customIcons/svg/HeartHand"
import Scissors from "./customIcons/svg/Scissors"
import Shield from "./customIcons/svg/Shield"
import SupportAgent from "./customIcons/svg/SupportAgent"
import LockPerson from "./customIcons/svg/LockPerson"
import LockPersonFilled from "./customIcons/svg/LockPersonFilled"
import MarkChatRead from "./customIcons/svg/MarkChatRead"
import FavouriteBorder from "./customIcons/svg/FavouriteBorder"
import Undo from "./customIcons/svg/Undo"
import Bicycle from "./customIcons/svg/Bicycle"
import Pointer from "./customIcons/svg/Pointer"
import Signature from "./customIcons/svg/Signature"
import MagicWand from "./customIcons/svg/MagicWand"
import SharedUsers from "./customIcons/svg/SharedUsers"
import Bolt from "./customIcons/svg/Bolt"
import Store from "./customIcons/svg/Store"
import Pound from "./customIcons/svg/Pound"
import PointingHand from "./customIcons/svg/PointingHand"

import ArrowPointerSolid from "./customIcons/svg/ArrowPointerSolid"
import ClipBoardCheckSolid from "./customIcons/svg/ClipBoardCheckSolid"
import CalenderDaySolid from "./customIcons/svg/CalenderDaySolid"
import Sell from "./customIcons/svg/Sell"
import VerifiedUser from "./customIcons/svg/VerifiedUser"
import Coins from "./customIcons/svg/Coins"

const EmptyIcon = styled.span``

export const iconPicker = (icon: IconTypes): ReactNode => {
  switch (icon) {
    case IconTypes.addAdmin:
      return AddAdmin
    case IconTypes.article:
      return Article
    case IconTypes.apps:
      return Apps
    case IconTypes.menu:
      return Menu
    case IconTypes.info:
      return Info
    case IconTypes.backArrow:
      return BackArrow
    case IconTypes.upArrow:
      return UpArrow
    case IconTypes.downArrow:
      return DownArrow
    case IconTypes.rightArrow:
      return RightArrow
    case IconTypes.payment:
      return Payment
    case IconTypes.trashcan:
      return Trashcan
    case IconTypes.angleLeft:
      return AngleLeft
    case IconTypes.angleRight:
      return AngleRight
    case IconTypes.angleUp:
      return AngleUp
    case IconTypes.angleDown:
      return AngleDown
    case IconTypes.favouriteOutline:
      return Favourite
    case IconTypes.simpleFavourite:
      return SimpleFavourite
    case IconTypes.simpleFavouriteOutline:
      return SimpleFavouriteOutline
    case IconTypes.newTab:
      return NewTab
    case IconTypes.landscape:
      return Landscape
    case IconTypes.question:
      return Question
    case IconTypes.circleTick:
      return CircleTick
    case IconTypes.circleHollow:
      return CircleHollow
    case IconTypes.perks:
      return Perks
    case IconTypes.logoBox:
      return LogoBox
    case IconTypes.close:
      return Close
    case IconTypes.oldComment:
      return OldComment
    case IconTypes.oldCommented:
      return OldCommented
    case IconTypes.comment:
      return Comment
    case IconTypes.addComment:
      return AddComment
    case IconTypes.emoji:
      return Emoji
    case IconTypes.emojiActive:
      return EmojiActive
    case IconTypes.addEmoji:
      return AddEmoji
    case IconTypes.customReward:
      return CustomReward
    case IconTypes.rewardActive:
      return RewardActive
    case IconTypes.addReward:
      return AddReward
    case IconTypes.vote:
      return Vote
    case IconTypes.voted:
      return Voted
    case IconTypes.oldReward:
      return OldReward
    case IconTypes.play:
      return Play
    case IconTypes.pause:
      return Pause
    case IconTypes.attachment:
      return Attachment
    case IconTypes.pin:
      return Pin
    case IconTypes.pinFilled:
      return PinFilled
    case IconTypes.piggyBank:
      return PiggyBank
    case IconTypes.visibility:
      return Visibility
    case DealHighlightTypes.DIGITAL:
      return Coupon
    case DealHighlightTypes.COMPANY_BENEFIT:
      return CompanyBenefit
    case DealHighlightTypes.PHYSICAL:
      return Physical
    case DealHighlightTypes.MERCHANDISE:
      return Package
    case DealHighlightTypes.COUPON:
      return Coupon
    case DealHighlightTypes.INSTANT:
      return Instant
    case DealHighlightTypes.ONE_HOUR:
      return OneHour
    case DealHighlightTypes.APP_ONLY:
      return MobileAppOnly
    case DealHighlightTypes.TIME_LIMIT_24_HOUR:
      return TimeLimitedPerk
    case DealHighlightTypes.SHIPPING_INCLUDED:
      return Truck
    case IconTypes.geoPin:
      return GeoPin
    case IconTypes.geoArrow:
      return GeoArrow
    case IconTypes.summaryComments:
      return SummaryComments
    case IconTypes.summaryRecognitions:
      return SummaryRecognitions
    case IconTypes.summaryTrophies:
      return SummaryTrophies
    case IconTypes.dotDotDot:
      return DotDotDot
    case IconTypes.i:
      return I
    case IconTypes.padlock:
      return Padlock
    case IconTypes.person:
      return Person
    case IconTypes.people:
      return People
    case IconTypes.sendExampleSurvey:
      return SendExampleSurvey
    case IconTypes.stop:
      return Stop
    case IconTypes.duplicate:
      return Duplicate
    case IconTypes.archive:
      return Archive
    case IconTypes.launch:
      return Launch
    case IconTypes.seeResults:
      return SeeResults
    case IconTypes.editQuestion:
      return EditQuestion
    case IconTypes.disabledEditQuestion:
      return DisabledEditQuestion
    case IconTypes.eyeSlash:
      return EyeSlash
    case IconTypes.google:
      return Google
    case IconTypes.outlook:
      return Outlook
    case IconTypes.restore:
      return Restore
    case IconTypes.delete:
      return Delete
    case IconTypes.more:
      return More
    case IconTypes.ellipsis:
      return Ellipsis
    case IconTypes.report:
      return Report
    case IconTypes.poll:
      return Poll
    case IconTypes.share:
      return Share
    case IconTypes.sharedUser:
      return SharedUser
    case IconTypes.heartOutline:
      return HeartOutline
    case IconTypes.tag:
      return Tag
    case IconTypes.sort:
      return Sort
    case IconTypes.filterActive:
      return FilterActive
    case IconTypes.removeBookmark:
      return RemoveBookmark
    case IconTypes.addBookmark:
      return AddBookmark
    case IconTypes.user:
      return User
    case IconTypes.userPlus:
      return UserPlus
    case IconTypes.userFilled:
      return UserFilled
    case IconTypes.logout:
      return Logout
    case IconTypes.help:
      return Help
    case IconTypes.myPerks:
      return MyPerks
    case IconTypes.myRecognition:
      return MyRecognition
    case IconTypes.dca:
      return DoctorCareAnywhere
    case IconTypes.mobileSecondaryNav:
      return MobileSecondaryNav
    case IconTypes.editPencil:
      return EditPencil
    case IconTypes.downloadFile:
      return DownloadFile
    case IconTypes.productsPerks:
      return ProductsPerks
    case IconTypes.productsMedical:
      return ProductsMedical
    case IconTypes.productsRecognition:
      return ProductsRecognition
    case IconTypes.productsWellness:
      return ProductsWellness
    case IconTypes.announcement:
      return Announcement
    case IconTypes.event:
      return Event
    case IconTypes.values:
      return Values
    case IconTypes.party:
      return Party
    case IconTypes.playVideo:
      return PlayVideo
    case IconTypes.reminder:
      return Reminder
    case IconTypes.clipboard:
      return Clipboard
    case IconTypes.blog:
      return Blog
    case IconTypes.clock:
      return Clock
    case IconTypes.newsletter:
      return Newsletter
    case IconTypes.fileDownload:
      return FileDownload
    case IconTypes.files:
      return Files
    case IconTypes.online:
      return Online
    case IconTypes.openTab:
      return OpenTab
    case IconTypes.refresh:
      return Refresh
    case IconTypes.adminRolesPermission:
      return AdminRolesPermissions
    case IconTypes.adminLoginIntegrations:
      return AdminLoginIntegrations
    case IconTypes.adminReports:
      return AdminReports
    case IconTypes.adminHelp:
      return AdminHelp
    case IconTypes.capsLockOn:
      return CapsLockOn
    // ============================================================ COMPONENT LIBRARY ICON SET
    case IconTypes.analytics:
      return Analytics
    case IconTypes.arrowDown:
      return ArrowDown
    case IconTypes.arrowLeft:
      return ArrowLeft
    case IconTypes.arrowRight:
      return ArrowRight
    case IconTypes.arrowUp:
      return ArrowUp
    case IconTypes.arrowUpDown:
      return ArrowUpDown
    case IconTypes.automation:
      return Automation
    case IconTypes.bin:
      return Bin
    case IconTypes.bookmark:
      return Bookmark
    case IconTypes.bookmarkFill:
      return BookmarkFill
    case IconTypes.businessUnit:
      return BusinessUnit
    case IconTypes.calendar:
      return Calendar
    case IconTypes.call:
      return Call
    case IconTypes.categories:
      return Categories
    case IconTypes.checklist:
      return Checklist
    case IconTypes.check:
      return Check
    case IconTypes.chevronDown:
      return ChevronDown
    case IconTypes.chevronLeft:
      return ChevronLeft
    case IconTypes.chevronRight:
      return ChevronRight
    case IconTypes.chevronUp:
      return ChevronUp
    case IconTypes.circle:
      return Circle
    case IconTypes.circleAlert:
      return CircleAlert
    case IconTypes.circleAlertFill:
      return CircleAlertFill
    case IconTypes.circleCrossFill:
      return CircleCrossFill
    case IconTypes.circleDisable:
      return CircleDisable
    case IconTypes.circleFastForward:
      return CircleFastForward
    case IconTypes.circleInformation:
      return CircleInformation
    case IconTypes.circlePause:
      return CirclePause
    case IconTypes.circlePlay:
      return CirclePlay
    case IconTypes.circleQuestion:
      return CircleQuestion
    case IconTypes.circleTickFill:
      return CircleTickFill
    case IconTypes.circleCheckFill:
      return CircleCheckFill
    case IconTypes.circleExpand:
      return CircleExpand
    case IconTypes.circleContract:
      return CircleContract
    case IconTypes.circleArrowRight:
      return CircleArrowRight
    case IconTypes.circlePlusFilled:
      return CirclePlusFilled
    case IconTypes.circleMinus:
      return CircleMinus
    case IconTypes.circleCelebration:
      return CircleCelebration
    case IconTypes.circlePerks:
      return CirclePerks
    case IconTypes.circleWellness:
      return CircleWellness
    case IconTypes.warning:
      return Warning
    case IconTypes.circleRewards:
      return CircleRewards
    case IconTypes.circleAdmin:
      return CircleAdmin
    case IconTypes.pinned:
      return Pinned
    case IconTypes.companyBenefit:
      return CompanyBenefit
    case IconTypes.mediaCourse:
      return MediaCourse
    case IconTypes.cross:
      return Cross
    case IconTypes.csvFile:
      return CsvFile
    case IconTypes.customisation:
      return Customisation
    case IconTypes.document:
      return Document
    case IconTypes.download:
      return Download
    case IconTypes.downloadReport:
      return DownloadReport
    case IconTypes.deletedFile:
      return DeletedFile
    case IconTypes.edit:
      return Edit
    case IconTypes.email:
      return Email
    case IconTypes.export:
      return Export
    case IconTypes.eye:
      return Eye
    case IconTypes.eyeDisabled:
      return EyeDisabled
    case IconTypes.favourite:
      return Favourite
    case IconTypes.favouriteFill:
      return FavouriteFill
    case IconTypes.funnel:
      return Funnel
    case IconTypes.filter1:
      return Filter1
    case IconTypes.filter2:
      return Filter2
    case IconTypes.filter3:
      return Filter3
    case IconTypes.filterHighToLow:
      return FilterHighToLow
    case IconTypes.filterLowToHigh:
      return FilterLowToHigh
    case IconTypes.filterUpAndDown:
      return FilterUpAndDown
    case IconTypes.generateReport:
      return GenerateReport
    case IconTypes.globe:
      return Globe
    case IconTypes.home:
      return Home
    case IconTypes.homeFill:
      return HomeFill
    case IconTypes.information:
      return Information
    case IconTypes.label:
      return Label
    case IconTypes.lightBulb:
      return LightBulb
    case IconTypes.location:
      return Location
    case IconTypes.minus:
      return Minus
    case IconTypes.notification:
      return Notification
    case IconTypes.notificationBold:
      return NotificationBold
    case IconTypes.notificationFilled:
      return NotificationFilled
    case IconTypes.multiComments:
      return MultiComments
    case IconTypes.multiCommentsFilled:
      return MultiCommentsFilled
    case IconTypes.package:
      return Package
    case IconTypes.pending:
      return Pending
    case IconTypes.plus:
      return Plus
    case IconTypes.pointer:
      return Pointer
    case IconTypes.profile:
      return Profile
    case IconTypes.results:
      return Results
    case IconTypes.reward:
      return Reward
    case IconTypes.reward2:
      return Reward2
    case IconTypes.search:
      return Search
    case IconTypes.send:
      return Send
    case IconTypes.settings:
      return Settings
    case IconTypes.shoppingCart:
      return ShoppingCart
    case IconTypes.singleMedia:
      return SingleMedia
    case IconTypes.speech:
      return Speech
    case IconTypes.speechPlus:
      return SpeechPlus
    case IconTypes.star:
      return Star
    case IconTypes.starFill:
      return StarFill
    case IconTypes.survey:
      return Survey
    case IconTypes.tick:
      return Tick
    case IconTypes.uploadReport:
      return UploadReport
    case IconTypes.wallet:
      return Wallet
    case IconTypes.hypnosis:
      return Hypnosis
    case IconTypes.meditation:
      return Meditation
    case IconTypes.sleepStories:
      return SleepStories
    case IconTypes.talkingTherapy:
      return TalkingTherapy
    case IconTypes.workout:
      return Workout
    case IconTypes.yoga:
      return Yoga
    case IconTypes.liveBanner:
      return LiveBanner
    case IconTypes.webinars:
      return Webinars
    case IconTypes.burgerMenu:
      return BurgerMenu
    case IconTypes.wellness:
      return Wellness
    case IconTypes.wellnessFill:
      return WellnessFill
    case IconTypes.medical:
      return Medical
    case IconTypes.medicalFill:
      return MedicalFill
    case IconTypes.celebration:
      return Celebration
    case IconTypes.celebrationFill:
      return CelebrationFill
    case IconTypes.celebrationNexus:
      return CelebrationNexus
    case IconTypes.rewards:
      return Rewards
    case IconTypes.rewardsFill:
      return RewardsFill
    case IconTypes.celebrationAnimated:
      return CelebrationAnimated
    case IconTypes.savingsAnimated:
      return SavingsAnimated
    case IconTypes.shareAnimated:
      return ShareAnimated
    case IconTypes.perksFill:
      return PerksFill
    case IconTypes.personSearch:
      return PersonSearch
    case IconTypes.rewardPoints:
      return RewardPoints
    case IconTypes.accessTime:
      return AccessTime
    case IconTypes.adminHome:
      return AdminHome
    case IconTypes.searchPeople:
      return SearchPeople
    case IconTypes.teams:
      return Teams
    case IconTypes.countries:
      return Countries
    case IconTypes.integration:
      return Integration
    case IconTypes.collapse:
      return Collapse
    case IconTypes.expand:
      return Expand
    case IconTypes.flexiPoints:
      return FlexiPoints
    case IconTypes.flexiPointsFilled:
      return FlexiPointsFilled
    case IconTypes.audio:
      return Audio
    case IconTypes.video:
      return Video
    case IconTypes.videoFilled:
      return VideoFilled
    case IconTypes.all:
      return All
    case IconTypes.flexi:
      return Flexi
    case IconTypes.uploadCSV:
      return UploadCSV
    case IconTypes.billing:
      return Billing
    case IconTypes.msTeams:
      return MsTeams
    case IconTypes.thumbsUp:
      return ThumbsUp
    case IconTypes.payments:
      return Payments
    case IconTypes.payByCard:
      return PayByCard
    case IconTypes.shareTo:
      return ShareTo
    case IconTypes.copy:
      return Copy
    case IconTypes.cultureHub:
      return CultureHub
    case IconTypes.cultureHubFill:
      return CultureHubFill
    case IconTypes.homeElectronics:
      return HomeElectronics
    case IconTypes.homeElectronicsFill:
      return HomeElectronicsFill
    case IconTypes.cycleToWork:
      return CycleToWork
    case IconTypes.cycleToWorkFill:
      return CycleToWorkFill
    case IconTypes.annualLeavePurchaseFill:
      return AnnualLeavePurchaseFill
    case IconTypes.annualLeavePurchase:
      return AnnualLeavePurchase
    case IconTypes.externalLink:
      return ExternalLink
    case IconTypes.hourGlass:
      return HourGlass
    case IconTypes.cart:
      return Cart
    case IconTypes.bicycle:
      return Bicycle
    case IconTypes.infoPrimary1:
      return InfoPrimary1
    case IconTypes.infoBlack:
      return InfoBlack
    case IconTypes.verifyBusiness:
      return VerifyBusiness
    case IconTypes.verifyIdentity:
      return VerifyIdentity
    case IconTypes.upRightArrow:
      return UpRightArrow
    case IconTypes.spinner:
      return Spinner
    case IconTypes.history:
      return History
    case IconTypes.orderManagement:
      return OrderManagement
    case IconTypes.heartHand:
      return HeartHand
    case IconTypes.scissors:
      return Scissors
    case IconTypes.shield:
      return Shield
    case IconTypes.supportAgent:
      return SupportAgent
    case IconTypes.lockPerson:
      return LockPerson
    case IconTypes.lockPersonFilled:
      return LockPersonFilled
    case IconTypes.markChatRead:
      return MarkChatRead
    case IconTypes.favouriteBorder:
      return FavouriteBorder

    case IconTypes.travelBenefit:
      return TravelBenefit
    case IconTypes.travelBenefitFill:
      return TravelBenefitFill
    case IconTypes.pensionTopUp:
      return PensionTopUp
    case IconTypes.pensionTopUpFill:
      return PensionTopUpFill
    case IconTypes.gymBenefit:
      return GymBenefit
    case IconTypes.gymBenefitFill:
      return GymBenefitFill
    case IconTypes.healthCashPlan:
      return HealthCashPlan
    case IconTypes.healthCashPlanFill:
      return HealthCashPlanFill
    case IconTypes.salaryFinance:
      return SalaryFinance
    case IconTypes.salaryFinanceFill:
      return SalaryFinanceFill
    case IconTypes.payrollGiving:
      return PayrollGiving
    case IconTypes.payrollGivingFill:
      return PayrollGivingFill
    case IconTypes.carBenefit:
      return CarBenefit
    case IconTypes.carBenefitFill:
      return CarBenefitFill
    case IconTypes.undo:
      return Undo
    case IconTypes.currency:
      return Currency
    case IconTypes.signature:
      return Signature
    case IconTypes.magicWand:
      return MagicWand
    case IconTypes.sharedUserSolid:
      return SharedUsers
    case IconTypes.bolt:
      return Bolt
    case IconTypes.pound:
      return Pound
    case IconTypes.pointingHand:
      return PointingHand
    case IconTypes.coins:
      return Coins
    case IconTypes.arrowPointerSolid:
      return ArrowPointerSolid
    case IconTypes.clipBoardCheckSolid:
      return ClipBoardCheckSolid
    case IconTypes.calenderDaySolid:
      return CalenderDaySolid
    case IconTypes.store:
      return Store
    case IconTypes.sell:
      return Sell
    case IconTypes.verifiedUser:
      return VerifiedUser
    default:
      return EmptyIcon
  }
}

export const isChevron = (icon: IconTypes) => {
  const chevrons = [IconTypes.chevronDown, IconTypes.chevronLeft, IconTypes.chevronRight, IconTypes.chevronUp]
  return chevrons.includes(icon)
}
